import React, { useState } from "react";
import logo from "../../assets/img/MM_Onboarding_Logo.png";
import { withOktaAuth } from "@okta/okta-react";
import LostDataModal from "../SharedComponents/LostDataModal";
import { useSelector } from "react-redux";

const StartApplicationHeader = (props) => {
  const [showModal, setShowModal] = useState(false);
  const { showLogoutModal } = useSelector((state) => state.logoutModal);

  const logout = async () => {
    await props.oktaAuth.signOut();
  };

  const handleModalOpen = () => {
    if (props.currentFormChanged === true || !!showLogoutModal) {
      setShowModal(true);
    } else {
      logout();
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  return (
    <div className="row" id="startAppHeader">
      <div className="col-lg-8 col-sm-6" id="mm-onboarding-logo">
        <img id="mm-logo" alt="MassMutual" src={logo} />
      </div>
      <div className="col-lg-4 col-sm-6">
        <button
          className="btn btn-link logout-button"
          onClick={handleModalOpen}
        >
          <h3 className="logout-button-text">
            <span className="icon-logout"></span>
            <span>Log Out</span>
          </h3>
        </button>
      </div>

      <LostDataModal
        isOpen={showModal}
        handleClose={handleModalClose}
        handleProceed={logout}
      />
    </div>
  );
};

export default withOktaAuth(StartApplicationHeader);
